import React, { useEffect, useState } from 'react';
import './Studio.scss';
import axios from 'axios';
import { API_URL } from '../../config';
import { handleClickDetail } from './auxFunctions.js';

export const Studio = () => {
	const [studioData, setStudioData] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState('');

	useEffect(() => {
		const fetchStudio = async () => {
			try {
				const res = await axios.get(`${API_URL}/studio`);
				if (res.data.ok) {
					const sorted = res.data.data.sort(
						(a, b) => a.order - b.order
					);
					setStudioData(sorted);
				}
			} catch (err) {
				console.error('Error fetching studio data:', err);
			}
		};

		fetchStudio();
	}, []);

	const selectedItem = studioData.find(
		(item) => item.category === selectedCategory
	);

	return (
		<div className='Studio'>
			{selectedItem ? (
				<div className='studio-img-container'>
					{selectedItem.image1?.secure_url && (
						<img
							src={selectedItem.image1.secure_url}
							alt={`Studio ${selectedItem.title} - 1`}
						/>
					)}
					{selectedItem.image2?.secure_url && (
						<img
							src={selectedItem.image2.secure_url}
							alt={`Studio ${selectedItem.title} - 2`}
						/>
					)}
					{selectedItem.image3?.secure_url && (
						<img
							src={selectedItem.image3.secure_url}
							alt={`Studio ${selectedItem.title} - 3`}
						/>
					)}
				</div>
			) : (
				<div className='studio-img-container'>
					<img
						src={require(`../../assets/img/studio_1.jpg`)}
						alt='fotografía de Iván Blanco'
					/>
					<img
						src={require(`../../assets/img/studio_2.jpg`)}
						alt='fotografía de Iván Blanco'
					/>
					<img
						src={require(`../../assets/img/studio_3.jpg`)}
						alt='fotografía de Iván Blanco'
					/>
				</div>
			)}

			<div className='studio-text-container'>
				<div className='studio-text-inner-container'>
					{studioData.map((item, index) => (
						<div key={index}>
							<details
								onClick={(e) =>
									handleClickDetail(e, {
										setSelectedCategory,
									})
								}
								category={item.category}
							>
								<summary>
									{item.title}
									<span>/</span>
								</summary>
								<div
									dangerouslySetInnerHTML={{
										__html: item.description,
									}}
								></div>
							</details>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
